import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {PluginsService} from "../../../sofbox/plugins.service";
// @ts-ignore
//import logoImg from "../../../../assets/images/logo-footer.png";
import { subHeader } from '../../../../constants/menu';

@Component({
  selector: 'app-co-branding',
  templateUrl: './co-branding.component.html',
  styleUrls: ['./co-branding.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class CoBrandingComponent implements OnInit {

  constructor(private plugins: PluginsService) { }

  public navLogo: string = 'https://memd-partner-landing-page-assets.s3-us-west-2.amazonaws.com/memd-logo.png';
  private subHeader: any;
  public footerText: string;
  currentDate: any;

  public navItems: any = [
    { href: '#iq-home', title: 'Home',
      _is_active : true,
      children: true,
      child: subHeader
    },
    { href: '#iq-about-us', title: 'About'},
    { href: '#iq-software-features', title: 'Features' },
    { href: '#iq-services', title: 'Services' },
    { href: '#iq-faq', title: 'Faq' },
    { href: '#contact', title: 'Contact' },
  ];

  public socialNavItems: any = [
    { href: '#', icon: '<i class="fab fa-twitter"></i>' },
    { href: '#', icon: '<i class="fab fa-facebook-f"></i>' },
    { href: '#', icon: '<i class="fab fa-google"></i>' },
    { href: '#', icon: '<i class="fab fa-github"></i>' },
  ];

  ngOnInit() {
    // Init all plugins...
    document.documentElement.style.setProperty('--primary-font', 'Monserrat');
    const current = this;
    this.currentDate = new Date();
    this.footerText = '© '+this.currentDate.getFullYear()+' MeMD, Inc';
    // tslint:disable-next-line:only-arrow-functions
    setTimeout(function() {
      current.plugins.index();
    }, 200);
  }

}
